import { render, staticRenderFns } from "./ContactoPage.vue?vue&type=template&id=0d8e45b4&scoped=true"
import script from "./ContactoPage.vue?vue&type=script&lang=js"
export * from "./ContactoPage.vue?vue&type=script&lang=js"
import style0 from "./ContactoPage.vue?vue&type=style&index=0&id=0d8e45b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8e45b4",
  null
  
)

export default component.exports